import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5d4f9c70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { rel: "nofollow" }
const _hoisted_2 = {
  class: "apy",
  rel: "nofollow"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "details-link",
  rel: "nofollow"
}, "Details »", -1))
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", {
    class: "popular-account",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.trackAdLink(_ctx.ad)), ["prevent"]))
  }, [
    _createElementVNode("td", null, [
      _createElementVNode("a", _hoisted_1, _toDisplayString(_ctx.ad.account.sectionName), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.$filters.percentageFilter(_ctx.ad.account.apy)), 1)
    ]),
    _createElementVNode("td", null, _toDisplayString(_ctx.ad.account.name), 1),
    _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currencyFormatFilter(_ctx.ad.account.min)), 1),
    _createElementVNode("td", null, _toDisplayString(_ctx.$filters.currencyFormatFilter(_ctx.ad.account.max)), 1),
    _createElementVNode("td", null, [
      _hoisted_3,
      _createElementVNode("img", {
        class: "tPixel",
        src: _ctx.$filters.formatTrackingFilter(_ctx.ad.pixel)
      }, null, 8, _hoisted_4)
    ])
  ]))
}